import { render, staticRenderFns } from "./AttendancePage.vue?vue&type=template&id=1496b91a&scoped=true"
import script from "./AttendancePage.vue?vue&type=script&lang=js"
export * from "./AttendancePage.vue?vue&type=script&lang=js"
import style0 from "./AttendancePage.vue?vue&type=style&index=0&id=1496b91a&prod&scoped=true&lang=css"
import style1 from "./AttendancePage.vue?vue&type=style&index=1&id=1496b91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496b91a",
  null
  
)

export default component.exports